
import Vue from 'vue';
import moment from 'moment';
import Modal from '@/components/Modal/index.vue';
import Table from '@/components/TableCustom/index.vue';
import Button from '@/components/Button/index.vue';
import { TableHeader } from '@/utils';
import { PaymentMethod } from '@/config/types';
import { updateStatusTerritory } from '@/services/territory/update-status-territory';

Vue.prototype.PaymentMethod = PaymentMethod;
moment.locale('pt-br');

const ticketStatus = {
  pending: 'Pendente',
  payed: 'Pago',
  cancelled: 'Cancelado',
};

export default Vue.extend({
  components: {
    Table,
    Modal,
    Button,
  },
  inject: ['getStepDate'],
  data() {
    return {
      headers: [
        {
          key: 'ticketName',
          value: 'Boletos',
          hideOrder: true,
          order: false,
        },
        {
          key: 'dueDate',
          value: 'Data de vencimento',
          hideOrder: true,
          order: false,
        },
        {
          key: 'status',
          value: 'Status',
          tag: true,
          order: false,
          hideOrder: true,
        },
        {
          key: 'urlFile',
          value: 'Download',
          link: true,
          hideOrder: true,
        },
      ] as TableHeader[],
      isOpenModal: false,
      isOpenModal2: true,
      isHidden: true,
    };
  },
  computed: {
    getData(): any[] {
      updateStatusTerritory(this.getStepDate.territory.id, true);
      return this.getStepDate.tickets.map((data) => ({
        ...data,
        status: ticketStatus[data.status],
        dueDate: moment(data.dueDate).format('L'),
        ticketName: this.capitalizeFirstLetter(moment(data.dueDate).format('MMMM')),
      }));
    },
  },
  methods: {
    getModalSecound() {
      this.isOpenModal = true;
      this.isOpenModal2 = false;
    },
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    closeModalSecound() {
      this.isOpenModal = false;
    },
    returnHome() {
      this.$router.push('/produtor/territory');
    },
  },
});
